import { graphqlRequest } from "../common/apiClient";

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
export const TERMS_DOCUMENT_ID = "terms_and_conditions";

export async function fetchPublicLegalDocument(documentId = TERMS_DOCUMENT_ID) {
  if (!API_BASE_URL) {
    throw new Error("REACT_APP_API_BASE_URL no configurada");
  }
  const url = `${API_BASE_URL}/public/legal/terms?document_id=${encodeURIComponent(documentId)}`;
  const res = await fetch(url);
  if (!res.ok) {
    throw new Error(`No se pudo cargar T&C (HTTP ${res.status})`);
  }
  return res.json();
}

const MY_LEGAL_STATUS_QUERY = `
  query MyLegalAcceptanceStatus($documentId: String!) {
    myLegalAcceptanceStatus(document_id: $documentId) {
      document_id
      required_version
      accepted_version
      acceptance_required
      read_url
    }
  }
`;

const ACCEPT_LEGAL_MUTATION = `
  mutation AcceptLegalDocument($input: AcceptLegalDocumentInput!) {
    acceptLegalDocument(input: $input) {
      tenant_id
      version
      accepted_at
    }
  }
`;

const ACCEPT_ONBOARDING_MUTATION = `
  mutation AcceptLegalDocumentOnboarding($input: AcceptLegalDocumentInput!) {
    acceptLegalDocumentOnboarding(input: $input) {
      tenant_id
      version
      accepted_at
    }
  }
`;

const LIST_VERSIONS_QUERY = `
  query ListLegalDocumentVersions($documentId: String!) {
    listLegalDocumentVersions(document_id: $documentId, limit: 50) {
      items {
        document_id
        version
        status
        content_hash
        created_at
        published_at
      }
    }
  }
`;

const LIST_ACCEPTANCES_QUERY = `
  query ListLegalAcceptances($tenantId: String) {
    listLegalAcceptances(tenant_id: $tenantId, limit: 50) {
      items {
        tenant_id
        document_id
        version
        accepted_at
        accepted_by_email
        context
      }
    }
  }
`;

const CREATE_UPLOAD_MUTATION = `
  mutation CreateLegalDocumentUploadUrl($input: CreateLegalDocumentUploadInput!) {
    createLegalDocumentUploadUrl(input: $input) {
      upload_id
      upload_url
      expires_at
      s3_key
    }
  }
`;

const PUBLISH_MUTATION = `
  mutation PublishLegalDocumentVersion($documentId: String!, $version: Int!) {
    publishLegalDocumentVersion(document_id: $documentId, version: $version) {
      version
      status
      published_at
    }
  }
`;

const ROLLBACK_MUTATION = `
  mutation RollbackLegalDocumentVersion($documentId: String!, $version: Int!) {
    rollbackLegalDocumentVersion(document_id: $documentId, version: $version) {
      version
      status
      published_at
    }
  }
`;

export async function fetchMyLegalAcceptanceStatus(documentId = TERMS_DOCUMENT_ID) {
  const data = await graphqlRequest(MY_LEGAL_STATUS_QUERY, { documentId });
  return data?.myLegalAcceptanceStatus;
}

export async function acceptLegalDocument(version, documentId = TERMS_DOCUMENT_ID) {
  const data = await graphqlRequest(ACCEPT_LEGAL_MUTATION, {
    input: { document_id: documentId, version, acknowledged_read: true },
  });
  return data?.acceptLegalDocument;
}

export async function acceptLegalDocumentOnboarding(version, documentId = TERMS_DOCUMENT_ID) {
  const data = await graphqlRequest(ACCEPT_ONBOARDING_MUTATION, {
    input: { document_id: documentId, version, acknowledged_read: true },
  });
  return data?.acceptLegalDocumentOnboarding;
}

export async function listLegalDocumentVersions(documentId = TERMS_DOCUMENT_ID) {
  const data = await graphqlRequest(LIST_VERSIONS_QUERY, { documentId });
  return data?.listLegalDocumentVersions?.items || [];
}

export async function listLegalAcceptances(tenantId) {
  const data = await graphqlRequest(LIST_ACCEPTANCES_QUERY, { tenantId: tenantId || null });
  return data?.listLegalAcceptances?.items || [];
}

export async function createLegalDocumentUploadUrl(file, documentId = TERMS_DOCUMENT_ID) {
  const data = await graphqlRequest(CREATE_UPLOAD_MUTATION, {
    input: {
      document_id: documentId,
      file_name: file.name || "terms.html",
      mime_type: file.type || "text/html",
      content_length: file.size,
    },
  });
  return data?.createLegalDocumentUploadUrl;
}

export async function publishLegalDocumentVersion(version, documentId = TERMS_DOCUMENT_ID) {
  const data = await graphqlRequest(PUBLISH_MUTATION, { documentId, version });
  return data?.publishLegalDocumentVersion;
}

export async function rollbackLegalDocumentVersion(version, documentId = TERMS_DOCUMENT_ID) {
  const data = await graphqlRequest(ROLLBACK_MUTATION, { documentId, version });
  return data?.rollbackLegalDocumentVersion;
}

export async function fetchLegalHtml(readUrl) {
  const res = await fetch(readUrl);
  if (!res.ok) throw new Error("No se pudo descargar el documento legal");
  return res.text();
}
